import { useEffect, useState } from "react";
import { getDataFromCmsApi } from "../../api/contentful-service.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faXTwitter, faYelp, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { Link } from "react-router-dom";


const Footer = () => {
    const [navItems, setNavItems] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const result = await getDataFromCmsApi("Navigation/Footer Menu");

        const getNavItems = result.items.map(section => ({
            title: section.name,
            items: (section.children || []).map(child => ({
                name: child.name,
                link: child.link
            }))
        }));

        setNavItems(getNavItems);
    };

    return (
        <footer className="footer mt-auto mx-auto py-3">
            <div className="d-flex justify-content-center">
                <div className="d-md-flex justify-content-center my-4">
                    <img
                        className="footer-logo img-fluid mb-4"
                        src="/assets/logos/sb-logo-full-color.png"
                        alt="San Bernardino County Logo"></img>
                    <svg className="footer-separator d-none d-md-block" width="90" height="200">
                        <line x1="20" y1="0" x2="20" y2="200"></line>
                    </svg>
                    <div className="">
                        <img
                            className="footer-atc img-fluid mb-4"
                            src="/assets/images/department-name.png"
                            alt="Auditor-Controller/Treasurer/Tax Collector"></img>
                        <div className="notranslate">
                            <p className="lead mb-0 text-light">268 W Hospitality Lane</p>
                            <p className="lead mb-0 text-light">San Bernardino, CA 92415</p>
                            <p className="lead mb-0 text-light">(909) 387-8308</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container fluid text-light my-4">
                <div className="row">
                    {navItems.map((section, index) => (
                        <ul key={index} className="col-6 col-md-2 list-unstyled">
                            <li className="h6">
                                <b>{section.title}</b>
                            </li>
                            {section.items.map((item, idx) => (
                                <li key={idx} className="py-1">
                                    <a
                                        href={item.link || "#"}
                                        className="text-blue-700 hover:underline">
                                        {item.name?.trim()}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </div>
            <div className="d-flex justify-content-center my-4">
                <a href="https://www.facebook.com/sanbernardinocountyatc/" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faFacebook} className="text-secondary m-2 social-icons" aria-label="Visit our Facebook profile" />
                    <span className="visually-hidden">Visit our Facebook profile</span>
                </a>
                <a href="https://mobile.twitter.com/atc_san" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faXTwitter} className="text-secondary m-2 social-icons" aria-label="Visit our Twitter profile" />
                    <span className="visually-hidden">Visit our Twitter profile</span>
                </a>
                <a href="https://www.instagram.com/sanbernardinocountyatc/" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faInstagram} className="text-secondary m-2 social-icons" aria-label="Visit our Instagram profile" />
                    <span className="visually-hidden">Visit our Instagram profile</span>
                </a>
                <a
                    href="https://www.yelp.com/biz/san-bernardino-county-tax-collector-san-bernardino-2?osq=San+Bernardino+County+Tax+Collector"
                    target="_blank"
                    rel="noreferrer">
                    <FontAwesomeIcon icon={faYelp} className="text-secondary m-2 social-icons" aria-label="Visit our Yelp profile" />
                    <span className="visually-hidden">Visit our Yelp profile</span>
                </a>
                <a
                    href="https://www.linkedin.com/company/san-bernardino-county-atc"
                    target="_blank"
                    rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} className="text-secondary m-2 social-icons" aria-label="Visit our LinkedIn profile" />
                    <span className="visually-hidden">Visit our LinkedIn profile</span>
                </a>
            </div>
            <div className="d-flex justify-content-center text-light upper-case px-2 text-center">
                <Link to="/privacy-policy" className="mx-1 text-white">
                    Privacy Policy
                </Link>{" "}
                |
                <Link to="/privacy-settings" className="mx-1 text-white">
                    Privacy Settings
                </Link>
            </div>
            <div className="d-flex justify-content-center text-light upper-case px-2 text-center">

                {new Date().getFullYear()} San Bernardino County Auditor Controller/Treasurer/Tax Collector - All Rights Reserved

            </div>
        </footer >
    );
};

export default Footer;
